
import { useTranslation } from "react-i18next";
import NewPage from "../../../layouts/page/NewPage";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useState } from "react";
import MenuConfig from "../../../../constants/MenuConfig";
import Form from "./Form";
import { getId, sendToApi } from "../../../../utils/ApiUtils";
import { useNavigate } from "react-router-dom";
import Api from "../../../../constants/Api";
import { convertBooleanToStatus } from "../../../../utils/ConverterUtils";

const ReasonNew = () => {

    const { t } = useTranslation();
    const [status, setStatus] = useState(true);
    const [entityData, setEntityData] = useState(null);
    const navigate = useNavigate();

    // Define o schema de validação do form.
    const formSchema = Yup.object().shape({
        name: Yup.string()
            .min(3, t("validation.min.generic", { field: t('name'), qty: 3 }))
            .required(t('validation.required.reason'))
    });

    // Define o formik.
    const formik = useFormik({
        initialValues: {
            name: ''
        },
        validationSchema: formSchema,
        onSubmit: values => {
            let payload = {
                id: getId(entityData),
                name: values.name,
                status: convertBooleanToStatus(status),
                type: 'CANCELLATION'
            }
            
            // Aciona a api
            sendToApi(Api.sales.reason, payload, () => {
                if(entityData == null) {
                    formik.resetForm();
                } else {
                    navigate(MenuConfig.sales.reason.route);
                }
            }, () => {
                formik.setSubmitting(false);
            });
        },
    });

    // Valida o form e em seguida submete os dados. Aciona o onSubmit do formik.
    const onSubmit = (e) => {
        e.preventDefault();
        formik.handleSubmit();
    }

    return (
        <>
            <NewPage
                motherMenu={t('sales')}
                childMenu={t('reasons_cancellation')}
                activeMenu={t('new')}
                child={<Form formik={formik} status={status} setStatus={setStatus} entityData={entityData}/>}
                setEntityData={setEntityData}
                path={Api.sales.reason}
                isSubmitting={formik.isSubmitting}
                handleSubmit={onSubmit}
                cancelRoute={MenuConfig.sales.reason.route}
            />
        </>
    );
}

export default ReasonNew;